import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { memo } from 'react'
import GaugeChart from 'react-gauge-chart'

import { flex, jc } from '~/modules/AppLayout/FlexGridCss'

export const PriceGauges = memo<ReactProps<{ currentValue: number }>>(function Gauges(props) {
  return (
    <PriceGaugeStyled.Container>
      <PriceGaugeStyled.GaugesMark>
        <PriceGaugeStyled.MarkItemTop
          width={100}
          margin={0}
        >
          <div>盤整</div>
        </PriceGaugeStyled.MarkItemTop>
        <PriceGaugeStyled.MarkItem
          width={60}
          margin={-18}
        >
          <div>偏空</div>
          <div>偏多</div>
        </PriceGaugeStyled.MarkItem>
        <PriceGaugeStyled.MarkItem
          width={88}
          margin={0}
        >
          <div>強空</div>
          <div>強多</div>
        </PriceGaugeStyled.MarkItem>
        <PriceGaugeStyled.MarkItem
          width={100}
          margin={8}
        >
          <div>過冷</div>
          <div>過熱</div>
        </PriceGaugeStyled.MarkItem>
      </PriceGaugeStyled.GaugesMark>
      <div
        css={css`
          ${flex.h.allCenter};
          position: absolute;
          margin-top: 22px;
          width: 100%;
        `}
      >
        <PriceGaugeStyled.Icon />
        <GaugeChart
          id={'chart'}
          percent={props.currentValue / 100}
          formatTextValue={() => ''}
          nrOfLevels={100}
          textColor='transparent'
          arcPadding={0.0}
          cornerRadius={0}
          arcWidth={0.1}
          needleBaseColor='#252525'
          needleColor='#252525'
          colors={['#54a843', '#8fd673', '#bce1ad', '#e9e9df', '#f7d1d0', '#e5a2a0', '#e45751']}
          arcsLength={[0.075, 0.075, 0.075, 0.075, 0.075, 0.075, 0.075]}
        />
      </div>
    </PriceGaugeStyled.Container>
  )
})

//動能大小的力道元件
export const PowerGauges = memo<ReactProps<{ currentValue: number }>>(function PowerGauges(props) {
  return (
    <PowerGaugeStyled.Container>
      <PowerGaugeStyled.GaugesMark>
        <PowerGaugeStyled.MarkItemTop
          width={100}
          margin={0}
        >
          <div>中</div>
        </PowerGaugeStyled.MarkItemTop>
        <PowerGaugeStyled.MarkItem
          width={88}
          margin={16}
        >
          <div>小</div>
          <div>大</div>
        </PowerGaugeStyled.MarkItem>
      </PowerGaugeStyled.GaugesMark>
      <div
        css={css`
          ${flex.h.allCenter};
          position: absolute;
          margin-top: 22px;
          width: 100%;
        `}
      >
        <PowerGaugeStyled.Icon />
        <GaugeChart
          id={'chart'}
          percent={props.currentValue || 0}
          formatTextValue={() => ''}
          nrOfLevels={999}
          textColor='transparent'
          arcPadding={0.0}
          cornerRadius={0}
          arcWidth={0.1}
          needleBaseColor='#252525'
          needleColor='#252525'
          colors={['#db494f', '#4051ce']}
        />
      </div>
    </PowerGaugeStyled.Container>
  )
})

const PowerGaugeStyled = {
  Container: styled.div`
    ${flex.v.crossCenter}
    width: 232px;
    height: 124px;
    position: relative;
    font-size: 14px;
  `,
  GaugesMark: styled.div`
    ${flex.v.allCenter};
    width: 100%;
    position: absolute;
    padding: 4px;
    color: #1b1851;
  `,
  MarkItemTop: styled.div<{ margin: number; width: number }>`
    ${flex.h.allCenter};
    width: ${props => props.width}%;
    height: 28px;
    margin-top: ${props => props.margin};
  `,
  MarkItem: styled.div<{ margin: number; width: number }>`
    ${flex.h.allCenter};
    ${jc.spaceBetween};
    width: ${props => props.width}%;
    height: 28px;
    margin-top: ${props => props.margin}px;
  `,
  Icon: styled.div`
    position: absolute;
    width: 140px;
    height: 70px;
    background: #11111111;
    border-radius: 70px 70px 0 0;
    margin-top: -6px;
    border: 1px solid #cacaca;
    border-width: 2px 2px 0 2px;
  `,
}

const PriceGaugeStyled = {
  Container: styled.div`
    ${flex.v.crossCenter}
    width: 232px;
    height: 124px;
    position: relative;
    font-size: 14px;
  `,
  GaugesMark: styled.div`
    ${flex.v.allCenter};
    width: 100%;
    position: absolute;
    padding: 4px;
    color: #1b1851;
  `,
  MarkItemTop: styled.div<{ margin: number; width: number }>`
    ${flex.h.allCenter};
    width: ${props => props.width}%;
    height: 28px;
    margin-top: ${props => props.margin};
  `,
  MarkItem: styled.div<{ margin: number; width: number }>`
    ${flex.h.allCenter};
    ${jc.spaceBetween};
    width: ${props => props.width}%;
    height: 28px;
    margin-top: ${props => props.margin}px;
  `,
  Icon: styled.div`
    position: absolute;
    width: 140px;
    height: 70px;
    background: #11111111;
    border-radius: 70px 70px 0 0;
    margin-top: -6px;
    border: 1px solid #cacaca;
    border-width: 2px 2px 0 2px;
  `,
}
